import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import type { ApiWaveDecision } from "@/generated/models/ApiWaveDecision";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import { fetchWaveDecisionsV2 } from "@/services/api/wave-decisions-v2-api";
interface UseWaveSalesDecisionsProps {
  readonly waveId: string;
  readonly wave?: ApiWave | ApiWaveMin | undefined;
  readonly enabled?: boolean | undefined;
}
const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 100;
const DEFAULT_STALE_TIME = 60000;
const sortDecisionPoint = (decisionPoint: ApiWaveDecision): ApiWaveDecision => ({
  ...decisionPoint,
  winners: [...decisionPoint.winners].sort((a, b) => a.place - b.place)
});
export function useWaveSalesDecisions(t0) {
  const $ = _c(20);
  const {
    waveId,
    wave,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== waveId) {
    t2 = [QueryKey.WAVE_DECISIONS_SALES, {
      waveId
    }];
    $[0] = waveId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== wave || $[3] !== waveId) {
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      const currentPage = pageParam ?? DEFAULT_PAGE;
      return await fetchWaveDecisionsV2({
        waveId,
        wave,
        params: {
          sort_direction: "DESC",
          sort: "decision_time",
          page: currentPage.toString(),
          page_size: DEFAULT_PAGE_SIZE.toString()
        }
      });
    };
    $[2] = wave;
    $[3] = waveId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== enabled || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      initialPageParam: DEFAULT_PAGE,
      getNextPageParam: _temp,
      enabled,
      staleTime: DEFAULT_STALE_TIME
    };
    $[5] = enabled;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data,
    isError,
    error,
    refetch,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteQuery(t4);
  data?.pages;
  let t5;
  if ($[9] !== data?.pages) {
    const mergedDecisionPoints = [];
    const seenDecisionTimes = new Set();
    for (const page of data?.pages ?? []) {
      for (const decisionPoint of page.data) {
        if (seenDecisionTimes.has(decisionPoint.decision_time)) {
          continue;
        }
        seenDecisionTimes.add(decisionPoint.decision_time);
        mergedDecisionPoints.push(sortDecisionPoint(decisionPoint));
      }
    }
    t5 = mergedDecisionPoints.sort(_temp2);
    $[9] = data?.pages;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const decisionPoints = t5;
  let t6;
  if ($[11] !== decisionPoints || $[12] !== error || $[13] !== fetchNextPage || $[14] !== hasNextPage || $[15] !== isError || $[16] !== isFetching || $[17] !== isFetchingNextPage || $[18] !== refetch) {
    t6 = {
      decisionPoints,
      isError,
      error,
      refetch,
      isFetching,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage
    };
    $[11] = decisionPoints;
    $[12] = error;
    $[13] = fetchNextPage;
    $[14] = hasNextPage;
    $[15] = isError;
    $[16] = isFetching;
    $[17] = isFetchingNextPage;
    $[18] = refetch;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp2(a, b) {
  return a.decision_time - b.decision_time;
}
function _temp(lastPage) {
  return lastPage.next ? lastPage.page + 1 : undefined;
}